// Color File Declaration
import {
    colors
} from "vuetify/lib";

export function color(name) {
    const colorMap = Object.freeze({
        red: colors.red.darken3,
        green: colors.green.darken1,
        blueGrey: colors.blueGrey.darken1,
        orange: colors.orange.darken2,
        purple: colors.purple.darken1,
        teal: colors.teal.darken1
    })

    return colorMap[name]
}

export function buttonColor(name){
    const colorMap = Object.freeze({
        new: "green",
        edit: "orange",
        save: "green",
        cancel: "red",
        close: "red",
        help: "blueGrey",
        approve: "green"
    })

    return color(colorMap[name])
}